import get from "lodash/get";
import { FIELD_AVAILABILITY_KEY } from "PFApp/constants/activity_form/activity_form_field_keys";
import { ROOT_ERROR_KEY } from "PFComponents/availability";
import { FieldErrors } from "react-hook-form";

export const getAvailabilityErrors = (formErrors: FieldErrors) => {
  const errors = get(formErrors, FIELD_AVAILABILITY_KEY);

  if (errors?.message) {
    return { [ROOT_ERROR_KEY]: errors?.message };
  }

  return errors;
};
